export const ADD_ONS_PATH = {
  GET_ALL_ADD_ONS: "v1/flights/bookings/addons/",
  POST_ALL_ADD_ONS: "v1/flights/bookings/addons/confirm/",
};

export const FLIGHT_API_PATH = {
  POST: "v1/flights/search/",
};

export const FLIGHT_RULES_PATH = {
  POST: "v1/flights/fare_rules/",
};

export const FLIGHT_PAX_WISE_FARE_BREAKDOWN = {
  GET: "v1/flights/search-fare-option-with-passenger-breakdown/",
};

export const AIRPORT_API_PATH = {
  GET: "/v1/flights/locations/",
};

export const FLIGHT_SEARCH_SETUP = {
  GET: "v1/flights/search-setup/",
};

export const FLIGHT_BOOKING_INITIATE_PATH = {
  POST: "v1/flights/bookings/initiate/",
};

export const FLIGHT_ACTIVE_PROVIDERS_AND_AIRLINES = {
  GET: "v1/flights/active-providers-and-airlines/",
};

export const NEW_FLIGHT_BOOKING_API_PATH = {
  GET: "v1/bookings/flight/:id",
  DOWNLOAD_TICKET:
    "v1/flights/bookings/get-booking/download-ticket/:id/?render_fare=:render_fare&is_edited=:is_edited&per_adult_edited_fare=:per_adult_edited_fare&per_child_edited_fare=:per_child_edited_fare&per_infant_edited_fare=:per_infant_edited_fare",
};

export const BOOKING_API_PATH = {
  GET: "v1/bookings/:id/",
  EDIT_PASSENGERS: "v1/bookings/{0}/passengers/",
  POST: "v1/flights/bookings/confirm/",
};

export const CANCEL_BOOKINGS_API_PATH = {
  POST: "v1/flights/bookings/cancel/",
};

export const DOWNLOAD_FLIGHT_TICKET = {
  GET: "v1/flights/bookings/download-ticket/:id/?render_fare=:render_fare&is_edited=:is_edited&per_adult_edited_fare=:per_adult_edited_fare&per_child_edited_fare=:per_child_edited_fare&per_infant_edited_fare=:per_infant_edited_fare",
};

export const FLIGHT_ISSUANCE_SALES_USER_API_PATH = {
  GET_SALES_USER: "salesuser/sales-user/",
};

export const FLIGHTS_PROMO_API_PATH = {
  APPLY_PROMO: "promo/apply_promo/",
  APPLY_PROMO_V2: "v2/promo/apply_promo/",
};

export const FLIGHT_ISSUANCE_API_PATH = {
  PNR_DETAILS: "v2/flights/pnr-details/",
  PNR_DETAILS_V3: "v3/flights/pnr-details/",
  PQ_CALCULATE_FARE: "v3/flights/calculate-fare/",
  ISSUE_TICKET: "v2/flights/issue-ticket/",
  ISSUE_TICKET_V3: "v3/flights/issue-ticket/",
};

export const FINANCIAL_PROFILE_API_PATH = {
  GET_ALL: "v1/financial-profile/",
};

export const VOID_TICKET = {
  COMMIT_VOID: "v1/flights/bookings/commit-void/",
  INITIATE_VOID: "v1/flights/bookings/initiate-void/",
};

export const GET_WEBSITE_CONFIG = {
  GET: "v1/organization/{0}/website/content/",
};

export const ORGANIZATION_PASSENGERSS = {
  GET: "v1/organization/{0}/passengers/",
  POST: "v2/organization/{0}/passengers/",
};

export const SEND_AIRLINE_TICKET = {
  POST: "/download-airline-ticket",
};

export const FLIGHT_REFUNDS_API_PATH = {
  FETCH_DETAILS: "flights/fetch-read-refund-details/",
  CALCULATE_DETAILS: "flights/calculate-refund-details/",
  COMMIT: "flights/commit-refund-details/",
  GET_ACTIVE_PROVIDERS: "flights/get-active-refund-providers/?organization_id=",
};
